// removed by extract-text-webpack-plugin
module.exports = {"Footer":"Footer__Footer__1Vs4w","Section":"Footer__Section__387Xn","Column":"Footer__Column__a-ha0","padding-left":"Footer__padding-left__30gRv"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Footer/Footer.css
// module id = 105
// module chunks = 0